import {
  createErrorOperationResult,
  createSuccessOperationResult,
} from '@hc-frontend/core-utils-business-operation';
import { isPhoenixZipCode } from '@hc-frontend/core-utils-validations';
import {
  UpdateProspectDto,
  updateProspectService,
} from '@hc-frontend/services';

import type {
  GetIsOepFromStateAcronymRepository,
  UpdateProspectLocationRepository,
} from '../../domain';

export function UpdateProspectLocationAdapterFactory({
  baseURL,
  getIsOepFromStateAcronym,
}: {
  baseURL: string;
  getIsOepFromStateAcronym: GetIsOepFromStateAcronymRepository['getIsOepFromStateAcronym'];
}): UpdateProspectLocationRepository {
  return async (parameters) => {
    try {
      let isOep = false;
      if (parameters.stateAcronym) {
        const isOepFromStateAcronym = await getIsOepFromStateAcronym(
          parameters.stateAcronym,
        );

        if (isOepFromStateAcronym.success) {
          isOep = isOepFromStateAcronym.data;
        }
      }

      const payload: UpdateProspectDto = {
        userId: parameters.userId,
        sessionId: parameters.sessionId,
        zip: parameters.zipCode,
        city: parameters.city,
        county: parameters.county,
        state: parameters.stateAcronym,
        countyFips: parameters.countyFips,
        additionalQuestions: {
          county_fips: parameters.countyFips,
          askForZipCode: false,
          is_phoenix: isPhoenixZipCode(parameters.zipCode),
          'is-oep': isOep ? 'is-oep-yes' : 'is-oep-no',
          'quality-life-event': isOep ? 'none-of-these' : undefined,
        },
        domainSessionId: parameters.domainSessionId,
        domainUserId: parameters.domainUserId,
      };

      const response = await updateProspectService(baseURL, payload);

      if (response.result !== 'success') {
        return createErrorOperationResult({
          errors: [
            {
              code: 'failedToUpdateProspectLocation',
              rootCause: new Error('Failed to update prospect location'),
            },
          ],
        });
      }

      return createSuccessOperationResult(undefined);
    } catch (error) {
      return createErrorOperationResult({
        errors: [
          {
            code: 'failedToUpdateProspectLocation',
            rootCause: error as Error,
          },
        ],
      });
    }
  };
}
